var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYCombinator = function SvgYCombinator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0H0v256h256V0Z",
    fill: "#FB651E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.374 144.746 75.433 62.431h20.081l25.848 52.093c.398.928.862 1.889 1.392 2.883.53.994.994 2.021 1.392 3.082.265.398.463.762.596 1.093.133.332.265.63.398.895a66.202 66.202 0 0 1 1.789 3.877c.53 1.26.994 2.419 1.392 3.48 1.06-2.254 2.22-4.673 3.479-7.257a959.034 959.034 0 0 0 3.877-8.053l26.246-52.093h18.689l-44.338 83.309v53.087h-16.9v-54.081Z",
    fill: "#fff"
  })));
};
export default SvgYCombinator;